module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f721466883998665b879.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/glyphicons-halflings-regular.svg
// module id = 1117
// module chunks = 2